import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import ButtonWithLoader from '../../../../commons/containers/ButtonWithLoader';

function ReclassifySpeciesDispatchModal(props) {
  const { open, onClose, onSubmit, process, loading } = props;
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [observation, setObservation] = useState('');
  const [reasonError, setReasonError] = useState('');

  useEffect(() => {
    if (!open) {
      setReason('');
      setObservation('');
      setReasonError('');
    }
  }, [open]);

  const submit = () => {
    if (!reason.trim()) {
      setReasonError(t('process.reclassification.reasonRequired'));
      return;
    }

    onSubmit({
      reason: reason.trim(),
      observation: observation.trim(),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t('process.reclassification.title')}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" style={{ marginBottom: '1rem' }}>
          {t('process.reclassification.description', {
            processId: process?.id || '-',
            callOff: process?.callOff || '-',
          })}
        </Typography>
        <TextField
          fullWidth
          multiline
          minRows={3}
          margin="normal"
          variant="outlined"
          label={t('Reason')}
          value={reason}
          onChange={(event) => {
            setReason(event.target.value || '');
            if (reasonError) setReasonError('');
          }}
          error={Boolean(reasonError)}
          helperText={reasonError}
        />
        <TextField
          fullWidth
          multiline
          minRows={2}
          margin="normal"
          variant="outlined"
          label={t('process.reclassification.observation')}
          value={observation}
          onChange={(event) => setObservation(event.target.value || '')}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('Cancel')}</Button>
        <ButtonWithLoader
          buttonId="reclassify-species-dispatch"
          loading={loading}
          onClick={submit}
          color="primary"
          variant="contained">
          {t('process.reclassification.confirm')}
        </ButtonWithLoader>
      </DialogActions>
    </Dialog>
  );
}

export default ReclassifySpeciesDispatchModal;
